import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MarsAndVenus = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M337.8 14.8C341.5 5.8 350.3 0 360 0h112c13.3 0 24 10.7 24 24v112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2 0 .6.1 1.2.1 1.8V407.8h24c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24V487.7h-48V484.7v.3V483.9v.1V473.9v.1V469.6v.4V456h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V387.8v.2V384c0-.6 0-1.2.1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160 39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264c0-53-43-96-96-96s-96 43-96 96 43 96 96 96 96-43 96-96z"
  }));
});
MarsAndVenus.displayName = 'MarsAndVenus';
export var MarsAndVenusDimensions = {
  height: 512,
  width: 512
};